import { Translate, useFormController } from '@dreryk/react-common';
import { Toggle } from '@dreryk/react-components';

import { generalSettingsTranslationKeys } from '../../../../translations';

import { useAppointmentConfigurationCreateOrUpdateCommand } from './OverlappingAppointmentsConfigurationForm.hooks';
import { OverlappingAppointmentsAllowedFormBean } from './OverlappingAppointmentsConfigurationForm.types';

type OverlappingAppointmentsConfigurationFormProps = { readonly overlappingAppointmentsAllowed: boolean };

export const OverlappingAppointmentsConfigurationForm = (
   props: OverlappingAppointmentsConfigurationFormProps
): JSX.Element => {
   const {
      loading: appointmentConfigurationCreateOrUpdateLoading,
      execute: appointmentConfigurationCreateOrUpdateCommand,
   } = useAppointmentConfigurationCreateOrUpdateCommand();

   const { register, handleSubmit } = useFormController<OverlappingAppointmentsAllowedFormBean>({
      overlappingAppointmentsAllowed: props.overlappingAppointmentsAllowed,
   });

   return (
      <form onInput={handleSubmit(appointmentConfigurationCreateOrUpdateCommand)}>
         <Toggle
            controller={register('overlappingAppointmentsAllowed')}
            testId={'overlappingAppointmentsAllowed'}
            rightSlot={<Translate>{generalSettingsTranslationKeys.calendar.overlappingAppointmentsAllowed}</Translate>}
            disabled={appointmentConfigurationCreateOrUpdateLoading}
         />
      </form>
   );
};
